import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different signin action types
*/
let initialstate = {
  isLoading: false,
  companies: [],
  pagination: {},
  searchText: '',
}
export default function company_operations(
  state = { ...initialstate },
  action
) {
  switch (action.type) {
    case ActionType.COMPANY_INPROGRESS:
      return { ...state, isLoading: action.isLoading }
    case ActionType.COMPANY_LIST:
      return {
        ...state,
        isLoading: action.isLoading,
        companies: action.companies,
        pagination: action.pagination,
        searchText: action.searchText,
      }
    case ActionType.LOGOUT:
      return initialstate
    default:
      return state
  }
}
